import React from 'react';
import GroupingDropdown from './GroupingDropdown';
import SortingControls from './SortingControls';
import ExportButton from './ExportButton';

const TableHeaderControls = ({ grouping, sorting, onGroupingChange, onSortingChange, onExport }) => (
  <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-3 mt-3 sm:mt-0 flex-wrap">
    <div className="min-w-0 flex-shrink">
      <GroupingDropdown grouping={grouping} onGroupingChange={onGroupingChange} />
    </div>
    <div className="min-w-0 flex-shrink">
      <SortingControls 
        sorting={sorting} 
        onSortingChange={onSortingChange} 
        grouping={grouping} 
      />
    </div>
    <div className="flex-shrink-0">
      <ExportButton onClick={onExport} />
    </div>
  </div>
);

export default TableHeaderControls;

